import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Book, Package, ArrowUpRight, ChefHat, Layers } from "lucide-react";
import ProductsPage from "@/pages/ProductsPage";
import RecipesPage from "@/pages/RecipesPage";
import IngredientsPage from "@/pages/IngredientsPage";
import { TAB_TONES } from "@/components/ui/color-tab";

/**
 * Unified master data page — Recipes, SKUs (Products), Ingredients in one place.
 * Super Admin lands here to set up everything the HO Production Planner needs
 * BEFORE creating plans.
 */
export default function RecipesAndSkusPage() {
  const [tab, setTab] = useState("skus");
  const tabs = [
    { id: "skus", label: "SKUs / Products", icon: Package, tone: "orange" },
    { id: "recipes", label: "Recipes", icon: Book, tone: "purple" },
    { id: "ingredients", label: "Ingredients", icon: Layers, tone: "slate" },
  ];
  return (
    <div className="space-y-4" data-testid="recipes-skus-master-page">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <div className="uc-label">Master Data · Production</div>
          <h1 className="font-[Outfit] text-3xl sm:text-4xl font-semibold tracking-tight mt-1">Recipes & SKUs Master</h1>
          <p className="text-sm text-[#8B7355] mt-1">
            Everything the HO Production Planner needs — products, recipes, and raw ingredients — in one place.
          </p>
        </div>
        <Link to="/app/ho-planner"
          className="text-sm text-[#C05621] hover:underline flex items-center bg-[#FEF9EA] border border-amber-200 rounded px-3 py-2">
          <ChefHat className="w-4 h-4 mr-1" /> Go to HO Production Planner
          <ArrowUpRight className="w-3 h-3 ml-1" />
        </Link>
      </div>

      {/* Tab bar — semantic ColorTab palette */}
      <div className="flex flex-wrap gap-0" data-testid="master-tabs">
        {tabs.map(t => {
          const active = tab === t.id;
          const tone = TAB_TONES[t.tone] || TAB_TONES.slate;
          return (
            <button
              key={t.id}
              onClick={() => setTab(t.id)}
              data-testid={`master-tab-${t.id}`}
              data-state={active ? "active" : "inactive"}
              className={`border rounded-md px-3 py-1.5 mx-0.5 my-0.5 text-sm font-medium flex items-center gap-1.5 transition-all shadow-sm data-[state=active]:shadow ${tone}`}
            >
              <t.icon className="w-3.5 h-3.5" /> {t.label}
            </button>
          );
        })}
      </div>

      <div className="pt-2">
        {tab === "skus" && <ProductsPage />}
        {tab === "recipes" && <RecipesPage />}
        {tab === "ingredients" && <IngredientsPage />}
      </div>
    </div>
  );
}
